<template>
    <iframe
        src="https://player.mux.com/kupXF3xVbg9yhFCaNtm1ISGxuR5FgVmrVpMrgN7BkzQ?metadata-video-title=Marshall Print Gallery&video-title=Final+comp_1&autoplay=1&loop=1&muted=1&controls=false"
        style="width: 100%; border: none; aspect-ratio: 12/5;"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowfullscreen
    ></iframe>
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
iframe {
  display: block;
}
</style>
